import { rest } from 'msw';

import { constants, getWebpackEnvVar, getEnvironment } from '@trqk/utils';

import { users } from './data';

const environment = getEnvironment();
const cognitoIDPUrl = getWebpackEnvVar('web', 'AWS_COGNITO_IDP_URL');

const testUserPublisherUsername = constants.TEST_USERS.PUBLISHER.USERNAME;

/**
 * Cognito uses two endpoints to authenticate users when using Auth.signIn() as we are doing in
 * packages/e2e/web/cypress/support/auth-provider-commands/cognito.js. This handler is for the
 * endpoint starting in 'cognito-idp', for example: https://cognito-idp.us-east-1.amazonaws.com/.
 *
 * The access token that is returned has expired, so any further requests using the access token
 * will need to have handlers as well. Typically, those will be defined in the appSyncHandlers
 * folder.
 */
export const cognitoIDPHandler = rest.post(cognitoIDPUrl, (req, res, ctx) => {
    if (typeof req.body === 'object') {
        const authParametersUsername =
            req?.body?.AuthParameters?.USERNAME ?? null;
        const authFlow = req?.body?.AuthFlow ?? null;
        const challengeResponseUsername =
            req?.body?.ChallengeResponses?.USERNAME ?? null;
        const challengeName = req?.body?.ChallengeName ?? null;
        const accessToken = req?.body?.AccessToken ?? null;

        /**
         * Begin logic for test user PUBLISHER
         */

        if (authParametersUsername === testUserPublisherUsername) {
            // Step 1
            if (authFlow === 'USER_SRP_AUTH') {
                return res(
                    ctx.json(
                        users.publisher.cognitoIDP.userSRPAuthResponse[
                            environment
                        ],
                    ),
                );
            }
        }

        if (
            challengeResponseUsername ===
            users.publisher.cognitoIDP.userSRPAuthResponse[environment]
                .ChallengeParameters.USERNAME
        ) {
            // Step 2
            if (challengeName === 'PASSWORD_VERIFIER') {
                return res(
                    ctx.json(
                        users.publisher.cognitoIDP.passwordVerifierResponse[
                            environment
                        ],
                    ),
                );
            }

            // Step 3

            if (
                accessToken ===
                users.publisher.cognitoIDP.passwordVerifierResponse[environment]
                    .AuthenticationResult.AccessToken
            ) {
                return res(
                    ctx.json(
                        users.publisher.cognitoIDP.deviceSecretVerifierResponse,
                    ),
                );
            }

            // Step 4

            if (challengeName === 'DEVICE_SRP_AUTH') {
                return res(
                    ctx.json(
                        users.publisher.cognitoIDP.deviceSRPAuthResponse[
                            environment
                        ],
                    ),
                );
            }
        }

        // Step 5

        if (
            accessToken ===
            users.publisher.cognitoIDP.passwordVerifierResponse[environment]
                .AuthenticationResult.AccessToken
        ) {
            return res(
                ctx.json(users.publisher.cognitoIDP.userResponse[environment]),
            );
        }

        /**
         * End logic for test user PUBLISHER
         */
    }

    return res();
});
